module.exports = __webpack_public_path__ + "assets/img/DS-room3 (14).821939c2.jpg";